<template>
  <!-- Estado de sucesso no lugar do formulario: o mesmo bloco serve o modal e
       o passo de demonstracao da tela de login, entao quem pediu nao precisa
       procurar a confirmacao em outro canto da tela. -->
  <div v-if="sent" class="form-sent">
    <h3>{{ $t('theForm.sentTitle') }}</h3>
    <h5 class="mt-2 font-weight-light">{{ $t('theForm.sentSubtitle') }}</h5>
  </div>

  <v-form v-else ref="form" class="form-cta" @submit.prevent="submit">
    <div>
      <div>
        <h5 class="my-3">{{ $t('theForm.firstName') }}</h5>
        <v-text-field
          v-model="form.firstName"
          :rules="[requiredRule]"
          :disabled="sending"
          dense
          outlined
          hide-details="auto"
        />
      </div>
      <div>
        <h5 class="my-3">{{ $t('theForm.lastName') }}</h5>
        <v-text-field
          v-model="form.lastName"
          :rules="[requiredRule]"
          :disabled="sending"
          dense
          outlined
          hide-details="auto"
        />
      </div>
      <div>
        <h5 class="my-3">{{ $t('theForm.businessEmail') }}</h5>
        <v-text-field
          v-model="form.email"
          :rules="[requiredRule, emailRule]"
          :disabled="sending"
          type="email"
          dense
          outlined
          hide-details="auto"
        />
      </div>
      <div>
        <h5 class="my-3">{{ $t('extras.phone') }}</h5>
        <div class="d-flex flex-row">
          <v-select
              outlined
              dense
              hide-details="auto"
              v-model="code"
              :items="codes"
              :disabled="sending"
              item-text="prefix"
              item-value="prefix"
              prepend-inner-icon="mdi-phone"
              class="phone-prefix-select"
            ></v-select>
          <v-text-field
            v-model="form.phone"
            :disabled="sending"
            class="flex-grow-1 phone-number"
            dense
            outlined
            hide-details="auto"
          />
        </div>
      </div>
    </div>
    <div>
      <div>
        <div>
          <h5 class="my-2">{{ $t('theForm.jobRole') }}</h5>
          <div class="mt-4">
            <v-select
              v-model="role"
              :items="roles"
              :rules="[selectionRule]"
              :disabled="sending"
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </div>
        </div>
        <div class="my-2">
          <h5 class="my-3">{{ $t('theForm.company') }}</h5>
          <v-text-field
            v-model="form.company"
            :rules="[requiredRule]"
            :disabled="sending"
            dense
            outlined
            hide-details="auto"
          />
        </div>

        <div class="my-2">
          <h5 class="my-3">{{ $t('theForm.countryOrRegion') }}</h5>
            <div class="mt-4">
              <v-select
                v-model="country"
                :items="countries"
                :rules="[selectionRule]"
                :disabled="sending"
                outlined
                dense
                hide-details="auto"
                item-text="country"
                item-value="country"
              ></v-select>
            </div>
        </div>
      </div>
    </div>
    <div class="mx-auto">
      <h5 class="font-weight-light" style="margin: auto">
        {{ $t('theForm.disclaimerBefore') }} <span>{{ $t('theForm.privacyPolicy') }}</span> {{ $t('theForm.disclaimerAfter') }}
      </h5>
    </div>

    <!-- Falha de envio fica junto do botao, nao em snackbar: no modal de demo
         o snackbar do app nasceria atras do overlay do v-dialog. -->
    <p v-if="error" class="form-error">{{ error }}</p>

    <v-btn
      type="submit"
      class="button-submit py-8"
      color="primary"
      :loading="sending"
      :disabled="sending"
    >
      <span style="color: black">{{ $t('instructions.submit') }}</span>
    </v-btn>
  </v-form>
</template>
<script>
import { COUNTRIES, COUNTRY_CODES, ROLES } from './constants';
import { sendRequestDemo } from '@/utils/requestDemo';

// O primeiro item das tres listas e um marcador ("Select one", "-"), nao uma
// escolha: e o valor inicial do campo e tambem o que a validacao recusa.
const ROLE_PLACEHOLDER = ROLES[0];
const COUNTRY_PLACEHOLDER = COUNTRIES[0];
const CODE_PLACEHOLDER = COUNTRY_CODES[0];

export default {
  props: ["items"],
  data(){
    return {
      role:ROLE_PLACEHOLDER,
      countries: COUNTRIES,
      codes: COUNTRY_CODES,
      code: CODE_PLACEHOLDER,
      roles: ROLES,
      countryCode: COUNTRY_CODES,
      country: COUNTRY_PLACEHOLDER,
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
      },
      sending: false,
      sent: false,
      error: "",
    };
  },
  computed: {
    requiredRule() {
      return (v) => !!(v && String(v).trim()) || this.$t('infoModal.errors.required');
    },
    emailRule() {
      return (v) => /.+@.+\..+/.test(v || '') || this.$t('infoModal.errors.invalidEmail');
    },
    selectionRule() {
      return (v) =>
        (!!v && v !== ROLE_PLACEHOLDER && v !== COUNTRY_PLACEHOLDER) ||
        this.$t('infoModal.errors.required');
    },
  },
  methods: {
    // O telefone e opcional; quando existe, o prefixo so entra se tiver sido
    // escolhido - senao o "-" da lista iria junto do numero.
    phoneField() {
      const number = this.form.phone.trim();
      if (!number) return "";
      const prefix = this.code && this.code !== CODE_PLACEHOLDER ? `${this.code} ` : "";
      return `${prefix}${number}`;
    },
    async submit() {
      if (this.sending) return;
      this.error = "";
      if (!this.$refs.form.validate()) return;

      this.sending = true;
      try {
        await sendRequestDemo({
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          phone: this.phoneField(),
          jobRole: this.role,
          company: this.form.company,
          country: this.country,
          locale: this.$i18n.locale,
          // De onde veio o pedido: o mesmo formulario e servido pelo modal de
          // demonstracao e pelo passo 5 da tela de login.
          origin: this.$route ? this.$route.fullPath : "",
        });
        this.sent = true;
        this.$emit('sent');
      } catch (e) {
        this.error = this.$t('theForm.sendError');
        this.$emit('error', e);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
/* Confirmacao no lugar do formulario: centralizada na mesma coluna que os
   campos ocupavam, sem caixa propria - o painel/modal ao redor ja e a caixa. */
.form-sent {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: clamp(1rem, 4dvh, 2.5rem) 0;
}
.form-sent h3 {
  font-size: clamp(0.9rem, 2.4dvh, 1.25rem);
  font-weight: 700;
}
.form-sent h5 {
  font-size: clamp(0.7rem, 1.6dvh, 0.9rem);
  color: #9aa3af;
  max-width: 34ch;
}

.form-error {
  margin: 0;
  font-size: clamp(0.6rem, 1.4dvh, 0.85rem);
  color: #ff5252;
}

.form-cta {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: clamp(0.5rem, 1vw, 1.5rem);
}

.form-cta h2 {
  font-size: clamp(0.6rem, 1.8dvh, 1.25rem);
  line-height: 1.2;
}

.form-cta h5 {
  font-size: clamp(0.45rem, 1.15dvh, 0.875rem);
  line-height: 1.15;
}

.form-cta ::v-deep .v-card-title {
  font-size: clamp(0.6rem, 1.8dvh, 1.25rem);
  padding: clamp(0.02rem, 0.6dvh, 0.5rem) 0;
}

.form-cta ::v-deep .my-4 {
  margin-top: clamp(0.02rem, 0.8dvh, 1rem) !important;
  margin-bottom: clamp(0.02rem, 0.8dvh, 1rem) !important;
}
.form-cta ::v-deep .my-3 {
  margin-top: clamp(0.02rem, 0.6dvh, 0.75rem) !important;
  margin-bottom: clamp(0.02rem, 0.6dvh, 0.75rem) !important;
}
.form-cta ::v-deep .my-2 {
  margin-top: clamp(0.02rem, 0.5dvh, 0.5rem) !important;
  margin-bottom: clamp(0.02rem, 0.5dvh, 0.5rem) !important;
}
.form-cta ::v-deep .mt-4 {
  margin-top: clamp(0.02rem, 0.6dvh, 1rem) !important;
}
.form-cta ::v-deep .mt-2 {
  margin-top: clamp(0.02rem, 0.5dvh, 0.5rem) !important;
}

.form-cta ::v-deep .v-input {
  font-size: clamp(0.5rem, 1.1dvh, 0.875rem);
}

.form-cta ::v-deep .v-text-field.v-text-field--outlined .v-input__control,
.form-cta ::v-deep .v-select.v-text-field--outlined .v-input__control,
.form-cta ::v-deep .v-text-field--outlined .v-input__slot {
  min-height: clamp(1.1rem, 4.2dvh, 2.5rem) !important;
}

.form-cta ::v-deep .v-label {
  font-size: clamp(0.45rem, 1.1dvh, 0.875rem);
}

.form-cta ::v-deep .v-input--radio-group .v-input--radio-group__input {
  gap: clamp(0rem, 0.3dvh, 0.25rem);
}

.form-cta ::v-deep .v-radio {
  margin-bottom: clamp(0rem, 0.15dvh, 0.25rem);
}

.form-cta ::v-deep .v-textarea textarea {
  line-height: 1.2;
  padding-top: clamp(0.05rem, 0.5dvh, 0.5rem) !important;
}

.form-cta ::v-deep .button-submit.py-7 {
  padding-top: clamp(0.1rem, 1.8dvh, 1.75rem) !important;
  padding-bottom: clamp(0.1rem, 1.8dvh, 1.75rem) !important;
}

.phone-prefix-select {
  flex: 0 0 110px;
  max-width: 100px;
  min-width: 85px;

}

::v-deep .phone-prefix-select .v-input__slot {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

::v-deep .phone-number .v-input__slot {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
